/**
 * Gets the device's browser language.
 *
 * @memberof module:i18n/Functions
 * @function getNavigatorLanguage
 * @returns {string | undefined} The language of the browser
 */
export default () => navigator.language ?? navigator.userLanguage;
